import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StartCourseMessage } from '../models/start-course-message.model';
import { EventMessage } from '../models/event-message.model';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  private apiUrl = `${environment.sgcApi}`;
  private messagesRoute = 'message/';
  private startCourseRoute = 'startcourse/';
  private eventRoute = 'events/';

  constructor(
    private httpClient: HttpClient
  ) { }

  getStartCourseMessages(dateFrom: Date, eventName: string) : Observable<StartCourseMessage[]> {
    const url = `${this.apiUrl}${this.messagesRoute}${this.startCourseRoute}${this.getMessageFilters(dateFrom, eventName)}`
    return this.httpClient.get<StartCourseMessage[]>(url).pipe(
      map((data) => data)
    );
  }

  getEventMessages(dateFrom: Date, eventName: string) : Observable<EventMessage[]> {
    const url = `${this.apiUrl}${this.messagesRoute}${this.eventRoute}${this.getMessageFilters(dateFrom, eventName)}`
    return this.httpClient.get<EventMessage[]>(url).pipe(
      map((data) => data)
    );
  }

  private getMessageFilters(dateFrom: Date, eventName: string) {
    let urlFilter = '?filters=';
    urlFilter += dateFrom ? 'dateFrom=' + dateFrom.toISOString().split('T')[0] + ';'  : '';
    urlFilter += eventName ? 'eventName=' + eventName + ';'  : '';
    return urlFilter;
  }
}
